import React, { useState } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";

const ServicePrFilter = ({
  applyFilter,
  listFilterData: _listFilterData = null,
}) => {
  const filterInputs = {
    site_no: "",
    status: "",
    id: "",
    firm_name: "",

  };

  const storageKey = "service_pr_filter";
  const savedFilter = JSON.parse(window.localStorage.getItem(storageKey) || "{}");

  const [filterFieldsData, setFilterFieldsData] = useState({
    site_no: savedFilter?.site_no || "",
    status: savedFilter?.status || "",
    id: savedFilter?.id || "",
    firm_name: savedFilter?.firm_name || "",

  });

  const statusList = [
    { id: "1", name: "Created" },
    { id: "2", name: "Approved By Procurement Executive" },
    { id: "3", name: "Approved By Procurement Head" },
    { id: "5", name: "Approved By Finance" },
    { id: "6", name: "Rejected" },
    { id: "7", name: "Closed" },
    { id: "8", name: "Pending" },
    { id: "9", name: "Approved by Installation Head" },
    { id: "10", name: "Approved by Maintenance Head" },
    { id: "11", name: "Sales Approval Pending" },
    { id: "12", name: "Edited" },
    { id: "19", name: "Sent Back for Modification" },
  ];

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        window.localStorage.setItem(storageKey, JSON.stringify(filterFieldsData));
        applyFilter(filterFieldsData);
      }}
    >

      <DropDownInput
        label={localization.status}
        data={statusList}
        value={statusList.find(item => item.id === filterFieldsData.status)?.name || ""}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, status: val.id })
        }
      />

      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />

      <ConstantInput
        label="PR Number"
        value={filterFieldsData.id}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, id: val })
        }
      />


      <ConstantInput
        label="Firm Name"
        value={filterFieldsData.firm_name}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, firm_name: val })
        }
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            window.localStorage.removeItem(storageKey);
            setFilterFieldsData(filterInputs);
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default ServicePrFilter;
